import { useAuth0 } from "@auth0/auth0-vue";
import { computed } from "vue";

import type { DpaNewsUser } from "@/types/user";

/**
 * Extends auth0 SDK to Cast the auth0 user to the correct type
 * this needs to happen as you can't extend the default User of auth0
 */
const useAuth = () => {
  const { user: auth0User, ...auth0Defaults } = useAuth0();

  //  error TS2352: use computed to cast the value
  const user = computed<DpaNewsUser | undefined>(
    () => auth0User.value as DpaNewsUser | undefined,
  );

  return {
    user,
    ...auth0Defaults,
  };
};

export default useAuth;
